<template>
  <section
    id="newsletter"
    class="footer-follow"
  >
    <!-- Title -->
    <div class="footer-follow__title">
      {{ $t('footer_2') }}
    </div>

    <!-- Subtitle -->
    <div class="footer-follow__subtitle">
      {{ $t('footer_3') }}
    </div>

    <!-- Button -->
    <input-ripple-view
      v-model="email"
      type="email"
      :marketing-concent="marketingConcent"
      :has-missing-concent="hasMissingConcent"
      placeholder="input_1"
      @click-submit="subscribe"
      @updateMarketingConcent="setMarketingConcent"
    >
      <template slot="icon">
        <i
          v-if="!loading"
          class="icon-pointer"
        />

        <icon-loading-view v-if="loading" />
      </template>
    </input-ripple-view>

    <!-- Message (success) -->
    <message-view :show="success && show">
      <!-- Title -->
      <template slot="title">
        {{ $t('message_1') }}
      </template>

      <!-- Message -->
      <template slot="message">
        {{ $t('message_2') }}
      </template>

      <!-- Action -->
      <template slot="action">
        <button-view
          type="submit"
          variant="center special"
          @click.native="show = false"
        >
          {{ $t('message_6') }}
        </button-view>
      </template>
    </message-view>

    <!-- Message (error) -->
    <message-view
      :has-close="true"
      :show="!success && show"
      @close-message="show = false"
    >
      <!-- Title -->
      <template slot="title">
        {{ $t('message_5') }}
      </template>

      <!-- Field -->
      <template slot="field">
        <input-view
          v-model="email"
          type="email"
          variant="error"
          placeholder="input_1"
          @click-submit="subscribe"
        >
          <template slot="icon">
            <i
              v-if="!loading"
              class="icon-pointer"
            />

            <icon-loading-view v-if="loading" />
          </template>
        </input-view>
      </template>

      <!-- Action -->
      <template slot="action">
        <button-view
          type="submit"
          variant="center special"
          @click.native="subscribe"
        >
          {{ $t('message_7') }}
        </button-view>
      </template>
    </message-view>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'FooterFollow',

  components: {
    IconLoadingView: () => import('@/icons/icon-loading-view'),
    InputRippleView: () => import('@/components/input/input-ripple-view'),
    MessageView: () => import('@/components/message/message-view'),
    ButtonView: () => import('@/components/button/button-view'),
    InputView: () => import('@/components/input/input-view')
  },

  data() {
    return {
      loading: false,
      success: false,
      show: false,

      email: '',

      marketingConcent: false,
      hasMissingConcent: false
    };
  },

  mounted() {
    if (window.location.hash !== '#newsletter') {
      return;
    }

    setTimeout(() => {
      this.$scrollTo('#newsletter');
    }, 500);
  },

  methods: {
    ...mapActions('contact', [
      'subscribeNewsletter'
    ]),

    setMarketingConcent(value) {
      this.marketingConcent = value;
    },

    async subscribe() {
      if (!this.marketingConcent) {
        this.hasMissingConcent = true;
        return;
      }

      if (this.loading) {
        return;
      }

      this.loading = true;

      try {
        await this.subscribeNewsletter([this.email, this.rgpdConcent, this.marketingConcent]);

        this.success = true;
      } catch (exception) {
        this.success = false;
      } finally {
        this.loading = false;
        this.show = true;
        this.hasMissingConcent = false;
      }
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/footer/footer-follow-view.scss"></style>



// WEBPACK FOOTER //
// footer-follow-view.vue